@if (errorAboveInput) {
  <div class="above-wrapper">
    <div class="placeholder">
      {{ placeholder | translate }}
    </div>
    @if (submitted) {
      <gl-error [message]="getErrorObjectFirstTranslationKey()"></gl-error>
    }
  </div>
}

<div
  class="input-wrapper"
  (glClickedOutside)="onClickedOutside()"
  [ignoreOverlay]="false"
  [ignoreClass]="'select-list'">
  <div class="wrapper">
    <div class="select-input">
      @if (placeholder && !errorAboveInput) {
        <div class="placeholder">
          {{ placeholder | translate }}
        </div>
      }
      <div class="input">
        <div class="chosen-option">
          {{ chosenOption?.text | translate }}
        </div>
        <gl-icon class="dropdown" [name]="'undo'"></gl-icon>
      </div>
    </div>
    <div class="errorWrapper">
      @if (submitted && !errorAboveInput) {
        <gl-error
          [message]="getErrorObjectFirstTranslationKey()"
        ></gl-error>
      }
    </div>
    <ng-template #list>
      <div class="select-list" [class.search-select]="searchOption" [ngClass]="{'longList': isLong, 'longerList': isLonger}">
        @if (searchOption) {
          <gl-search-input
            (searchChange)="onSearch($event)"
            [select]="true"
          ></gl-search-input>
        }
        <ng-content></ng-content>
        @if (searchOption && options.length === 0) {
          <div class="select-no-results" role="status">
            {{ 'country_filter_no_results' | translate }}
          </div>
        }
      </div>
    </ng-template>
  </div>
</div>
